module.exports = "https://trybtryb-legacy.web.app/img/present.537dc0af.svg";